module.exports = __webpack_public_path__ + "static/media/billboard.2406232c.png";